import { queryOptions } from '@tanstack/react-query'
import dayjs from 'dayjs'

import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'

import { type ResClientPortalInternalCaseInformationQuery } from './types'

export const clientPortalInternalCaseInformationQuery = (caseId: number) =>
  queryOptions<ResClientPortalInternalCaseInformationQuery>({
    queryKey: [API_ENDPOINTS['case-dashboard'].v1.portal.cases.index, caseId],
    queryFn: () => w.get(`${API_ENDPOINTS['case-dashboard'].v1.portal.cases.index}/${caseId}`).json(),
    select: (response) => {
      return {
        ...response,
        visaBulletinTrend: response?.visaBulletinTrend?.sort(
          (a, b) => dayjs(a.bulletinDate).diff(b.bulletinDate, 'day') // sort by descending order
        ),
      }
    },
  })
